import {ITools} from '@baidu/icloud-ui-pro-table';

//  工作区
export const tools: ITools = [
    {
        renderType: 'refresh',
    },
];
